export function getCanvasSizeInfo(): {
  width: number;
  height: number;
  dpr: number;
} {
  const body_width = window.document.body.clientWidth;
  const body_height = window.document.body.clientHeight;
  const dpr = window.devicePixelRatio || 1;
  return {
    width: body_width - 40,
    height: body_height - 40 - 14,
    dpr,
  };
}
